import React from 'react';

export interface EnvironmentVariables {
  appEnvironment?: string;
  appHost?: string;
  appsFlyerWebKey?: string;
  braintreeKey?: string;
  buildTarget?: string;
  clubSodaHost?: string;
  commitHash?: string;
  customerManagementHost?: string;
  datadogClientToken?: string;
  datadogRumApplicationId?: string;
  datadogRumClientToken?: string;
  deliveryManagementUiHost?: string;
  directConnectGraphQLEndpoint?: string;
  ezmarketingHubspotFormid?: string;
  ezmarketingHubspotPortalid?: string;
  ezRailsDomain?: string;
  featureFlagHost?: string;
  fullStoryOrgKey?: string;
  googleAnalyticsKey?: string;
  intercomAppId?: string;
  isProduction?: boolean;
  isTest?: boolean;
  nonce?: string;
  overridePublicPath?: string;
  promoServiceHost?: string;
  publicAssetUrl?: string;
  sentryDsn?: string;
  shortlinkHost?: string;
  trackingHost?: string;
}

export default React.createContext<EnvironmentVariables>({});
